.m-spinner-ball {
  display: inline-block;
  vertical-align: middle;

  g {
    fill: #e16e7c; // ENG-20847 medicus pink (middle ball)
    color: #e16e7c;

    :first-child {
      fill: var(--status-green);
      color: var(--status-green);
    }

    :last-child {
      fill: var(--theme-blue);
      color: var(--theme-blue);
    }
  }
}
